<template>
    <div v-if="showOptions" class="font-medium text-gray-600 text-lg mb-2">
        Elegir opción
    </div>
    <div
        v-if="showReturnServices"
        class="font-medium text-gray-600 text-lg mb-2"
    >
        Servicios disponibles para devolución
    </div>
    <div
        v-if="showChangeServices"
        class="font-medium text-gray-600 text-lg mb-2"
    >
        Servicios disponibles para cambio
    </div>
    <div
        v-if="showReturnDetails"
        class="font-medium text-gray-600 text-lg mb-2"
    >
        Detalles para devolución
    </div>
    <div
        v-if="showChangeDetails"
        class="font-medium text-gray-600 text-lg mb-2"
    >
        Detalles para cambio
    </div>
</template>

<script>
export default {
    name: "MultistepHeader",
    props: {
        processState: Object,
        message,
    },
    data() {
        return {
            showOptions: true,
            showReturnServices: false,
            showChangeServices: false,
            showReturnDetails: false,
            showChangeDetails: false,
        };
    },
    watch: {
        processState: {
            handler(newValue) {
                switch (newValue.step) {
                    case 1:
                        this.showOptions = false;
                        if (newValue.option === "cambio") {
                            this.showChangeServices = true;
                        } else if (newValue.option === "devolucion") {
                            this.showReturnServices = true;
                        }
                        break;
                    case 2:
                        this.showChangeServices = false;
                        this.showReturnServices = false;
                        if (newValue.option === "cambio") {
                            this.showChangeDetails = true;
                        } else if (newValue.option === "devolucion") {
                            this.showReturnDetails = true;
                        }
                        break;
                }
            },
            deep: true,
        },
    },
};
</script>
